import _ from "@lodash";
import { AppBar, DialogActions, DialogContent, Toolbar, Typography, withStyles } from "@material-ui/core";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import ConfirmacaoApp from "app/Core/Components/Confirmacao/ConfirmacaoApp";
import XAPPDialog from "app/Core/Components/Dialog/XAPPDialog";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import { cancelarAssinatura } from "app/Core/Funcionalidade/Pagamento/Store/Actions/PagamentoActions";
import MobileDetect from "mobile-detect";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import AgendamentoEdicaoFactory from "./AgendamentoEdicaoFactory";
import * as Actions from "./Store/Actions/AgendamentoEdicaoActions";

const md = new MobileDetect(window.navigator.userAgent);

const styles = () => ({
   dialogPaper: {
      minHeight: "100%",
      maxHeight: "100%",
   },
});

class AgendamentoEdicaoDialog extends XAPPComponent {
   getTituloDialog = () => {
      const { idagendamento, TIPOS_AGENDAMENTO, tipo } = this.props;
      let AResponse = "Novo ";
      if (!_.isUndefined(idagendamento) && !_.isNull(idagendamento)) {
         AResponse = "Editar ";
      }
      if (_.findIndex(TIPOS_AGENDAMENTO, { id: tipo }) !== -1) {
         return AResponse + _.find(TIPOS_AGENDAMENTO, { id: tipo }).value;
      } else {
         return AResponse + "Agendamento";
      }
   };

   render() {
      const { classes, dialog, openDialog, handleChangeCheck, openContent, showWebex, cancelarAssinatura, xappRouteParams, getBaseFiltro, user, callback, save, form, canBeSubmitted, idagendamento, handleChange, handleChangeMulti, handleLookupClientes, handleProdutos, handleResponsaveis, handleChangeData, getEmpresaClienteLookup, getProdutos, getHorarioAgendadoAll, view, get, TagsPessoa, TagsAgendamento, HorarioAgendado, EmpresaPessoaProduto, EmpresaLocais, canScheduleWebex, EmpresaStatus, saveAgendamentoPessoa, handleLookupFontePagadora, getEmpresaFontePagadoraLookup, getResponsaveis, handleChangeAnotacoes, TIPOS_AGENDAMENTO, handleChangeHorarios, checkHorarioDisponivel, handleChangePreAtendimento, } = this.props;

      return (
         <React.Fragment>
            {//!_.isUndefined(dialog[idagendamento]) && !_.isNull(dialog[idagendamento]) &&
               <XAPPDialog
                  open={!_.isUndefined(dialog[idagendamento]) && !_.isNull(dialog[idagendamento])}
                  onClose={() => openDialog(idagendamento)}
                  fullWidth
                  fullScreen
                  key={"AgendamentoEdicaoDialog_" + idagendamento}
                  id={"AgendamentoEdicaoDialog_" + idagendamento}
                  classes={{ paper: classes.dialogPaper }}
               >
                  <AppBar position="static" elevation={1}>
                     <Toolbar className="flex w-full min-h-0">
                        <Typography variant="subtitle1 text-white">{this.getTituloDialog()}</Typography>
                        <div style={{ flex: 1 }} />
                        <XAPPButton
                           type="Icon"
                           key="close"
                           aria-label="Close"
                           className="p-6"
                           onClick={() => {
                              openDialog(idagendamento);
                              if (!_.isUndefined(callback) && !_.isNull(callback)) {
                                 callback();
                              }
                           }}
                           icon={"close"}
                           iconProps={"text-20 text-white"}
                        />
                     </Toolbar>
                  </AppBar>
                  <DialogContent className={"p-0"}>
                     <AgendamentoEdicaoFactory
                        idagendamento={idagendamento}
                        handleChange={handleChange}
                        handleChangeCheck={handleChangeCheck}
                        handleChangeHorarios={handleChangeHorarios}
                        handleChangeMulti={handleChangeMulti}
                        handleLookupClientes={handleLookupClientes}
                        handleProdutos={handleProdutos}
                        handleResponsaveis={handleResponsaveis}
                        handleChangeData={handleChangeData}
                        handleLookupFontePagadora={handleLookupFontePagadora}
                        getEmpresaFontePagadoraLookup={getEmpresaFontePagadoraLookup}
                        getEmpresaClienteLookup={getEmpresaClienteLookup}
                        getProdutos={getProdutos}
                        getResponsaveis={getResponsaveis}
                        checkHorarioDisponivel={checkHorarioDisponivel}
                        handleChangeAnotacoes={handleChangeAnotacoes}
                        canBeSubmitted={canBeSubmitted}
                        TIPOS_AGENDAMENTO={TIPOS_AGENDAMENTO}
                        EmpresaLocais={EmpresaLocais}
                        EmpresaPessoaProduto={EmpresaPessoaProduto}
                        EmpresaStatus={EmpresaStatus}
                        HorarioAgendado={!_.isNull(HorarioAgendado) ? HorarioAgendado[idagendamento] : []}
                        TagsAgendamento={TagsAgendamento}
                        TagsPessoa={TagsPessoa}
                        xappRouteParams={xappRouteParams}
                        getBaseFiltro={getBaseFiltro}
                        saveAgendamentoPessoa={saveAgendamentoPessoa}
                        getHorarioAgendadoAll={getHorarioAgendadoAll}
                        handleChangePreAtendimento={handleChangePreAtendimento}
                        canScheduleWebex={canScheduleWebex}
                        showWebex={showWebex}
                        view={view}
                        form={form}
                        get={get}
                        save={save}
                        callback={callback}
                        user={user}
                        openContent={openContent}
                     />
                  </DialogContent>
                  <AppBar position="static" elevation={3} color="textSecondary">
                     <Toolbar className="flex w-full justify-end min-h-0">
                        <DialogActions>
                           {!_.isNull(form.idagendamento) && form.preatendimento.idassinatura &&
                              <XAPPButton
                                 type="Button"
                                 className="text-white mr-8"
                                 variant="contained"
                                 color="primary"
                                 iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                 icon={"close"}
                                 label={md.mobile() === null && md.tablet() === null ? "Cancelar assinatura" : ""}
                                 onClick={() => {
                                    cancelarAssinatura({
                                       idagendamento: form.idagendamento,
                                       preatendimento: form.preatendimento,
                                       idassinatura: form.preatendimento.idassinatura
                                    }, xappRouteParams, () => get(form.idagendamento, xappRouteParams));
                                 }}
                              />
                           }
                           {!_.isNull(form.idagendamento) && [1, 2, 3].includes(form.tipo) && (
                              <ConfirmacaoApp
                                 id="Cancelar"
                                 mensagem={
                                    "Tem certeza que deseja cancelar este agendamento, após essa operação este registro estará inacessível, confirma?"
                                 }
                                 type="Button"
                                 className="text-white mr-8"
                                 variant="contained"
                                 color="primary"
                                 disabled={!canBeSubmitted()}
                                 iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                 icon={"close"}
                                 label={md.mobile() === null && md.tablet() === null ? "Cancelar" : ""}
                                 onConfirmation={() => {
                                    save(form, xappRouteParams, "CANCELAR", () => {
                                       if (("" + idagendamento).includes("new_")) {
                                          openDialog(idagendamento);
                                       }
                                       if (!_.isUndefined(callback) && !_.isNull(callback)) {
                                          callback();
                                       }
                                    });
                                 }}
                              />
                           )}
                           <XAPPButton
                              type="Button"
                              className="text-white mr-8"
                              variant="contained"
                              color="primary"
                              disabled={!canBeSubmitted()}
                              iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                              icon={"save"}
                              label={md.mobile() === null && md.tablet() === null ? "Salvar" : ""}
                              onClick={() => {
                                 save(form, xappRouteParams, _.isNull(form.idagendamento) ? "INSERIR" : "ATUALIZAR", () => {
                                    if (("" + idagendamento).includes("new_")) {
                                       openDialog(idagendamento);
                                    }
                                    if (_.isNull(form.idagendamento) && !_.isUndefined(callback) && !_.isNull(callback)) {
                                       callback();
                                    }
                                 });
                              }}
                           />
                        </DialogActions>
                     </Toolbar>
                  </AppBar>
               </XAPPDialog>
            }
         </React.Fragment>
      );
   }
}

function mapDispatchToProps(dispatch) {
   return bindActionCreators(
      {
         get: Actions.get,
         getBaseFiltro: Actions.getBaseFiltro,
         save: Actions.save,
         openDialog: Actions.openDialog,
         cancelarAssinatura: cancelarAssinatura,
      },
      dispatch
   );
}

function mapStateToProps({ AgendamentoEdicao, auth }) {
   return {
      user: auth.user.data,
      AgendamentoEdicao: AgendamentoEdicao,
      EmpresaLocais: AgendamentoEdicao.locaisempresa,
      EmpresaPessoaProduto: AgendamentoEdicao.pessoasprodutosempresa,
      dialog: AgendamentoEdicao.dialog,
      EmpresaStatus: AgendamentoEdicao.statusempresa,
   };
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(AgendamentoEdicaoDialog)));
